// Shared constants for the Announcements module.

// Absolute route paths (mounted under AppRoutes at /*).
export const ROUTES = {
  essList:     "/hrms-ess/announcements",
  essDetail:   (id) => `/hrms-ess/announcements/detail/${id}`,
  creatorList: "/hrms-team/announcements",
  creatorDetail: (id) => `/hrms-team/announcements/detail/${id}`,
  hrReview:    "/hrms-team/announcements/review",
};

// Recipient options for the create/edit form.
export const AUDIENCE_OPTIONS = [
  "Global",
  "Managers",
  "Reportees",
  "Directors",
  "Department",
  "HR",
];

// Status pill colours. Actual hex values live as CSS custom properties in
// src/styles/globals.css so any module can reuse them, not just this one.
export const STATUS_STYLES = {
  Submitted:              { bg: "var(--status-submitted-bg)", color: "var(--status-submitted-fg)", dot: "var(--status-submitted-dot)" },
  Published:              { bg: "var(--status-published-bg)", color: "var(--status-published-fg)", dot: "var(--status-published-dot)" },
  "Required Corrections": { bg: "var(--status-warning-bg)",   color: "var(--status-warning-fg)",   dot: "var(--status-warning-dot)" },
  Draft:                  { bg: "var(--status-warning-bg)",   color: "var(--status-warning-fg)",   dot: "var(--status-warning-dot)" },
  Archived:               { bg: "var(--status-archived-bg)",  color: "var(--status-archived-fg)",  dot: "var(--status-archived-dot)" },
  Rejected:               { bg: "var(--status-rejected-bg)",  color: "var(--status-rejected-fg)",  dot: "var(--status-rejected-dot)" },
};

// #EF4444 / #3D5AF1 already exist as global tokens (--color-error / --color-accent
// in globals.css), so reuse them instead of redefining the same hex here.
export const IMPORTANT_COLOR = "var(--color-error)";
export const GENERAL_COLOR   = "var(--color-accent)";

export const MAX_FILE_BYTES = 5 * 1024 * 1024;
export const ALLOWED_EXTENSIONS = ["pdf", "jpg", "jpeg", "doc", "docx"];

// "Pending" (API) is shown to creators as "Submitted".
export function toUiStatus(apiStatus) {
  const s = (apiStatus ?? "").toLowerCase();
  if (s === "pending") return "Submitted";
  if (s === "published") return "Published";
  if (s === "required corrections") return "Required Corrections";
  if (s === "draft") return "Draft";
  if (s === "archived") return "Archived";
  if (s === "rejected") return "Rejected";
  return apiStatus;
}

export function formatDate(value) {
  if (!value) return "";
  const d = new Date(value);
  return isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}
